module.exports = {
  title: 'Smooth Dropdown Animation with Reanimated 👇',
  author: 'Enzo Manuel Mangano',
  date: '2023-04-05',
  slug: 'smooth-dropdown',
  tags: ['reanimated'],
};
